// extracted by mini-css-extract-plugin
export var ratingButton = "C_b5";
export var ratingButtonMaxRating5 = "C_b7";
export var ratingButtonSelected = "C_b6";